import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { User } from 'src/app/shared/models/user.model';
import { Store } from 'src/app/core/store/store';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  url = environment.apiBaseUrl;
  constructor(private http: HttpClient,private store: Store) { }

  getToken(){
    const data = localStorage.getItem("token");
    if(data){
      return data;
    }
    else{
      return null;
    }
  }

  public getProfile(uuid : string){
    const headers = new HttpHeaders({
        Authorization: `${this.getToken()}`
    });
    return this.http.get(`${this.url}ipj/user/profile`,{headers})
  }
  
  public updateProfile(data :any){
      const headers = new HttpHeaders({
        Authorization: `${this.getToken()}`
    });
    return this.http.put(`${this.url}ipj/user/profile-with-pic`,data,{headers});
  }
  
  public resetPswd(newPassword: any){
    const headers = new HttpHeaders({
        Authorization: `${this.getToken()}`
    });
    return this.http.put(`${this.url}ipj/user/reset-password-with-old-password`,newPassword,{headers});
  }

  public updateUser(firstName : any){
    const headers = new HttpHeaders({
      Authorization: `${this.getToken()}`
  });
  return this.http.put(`${this.url}ipj/user/profile`,firstName,{headers});
  }

  setUserData() {
    this.http.get<{ data: User, result: number, msg: string }>(`${this.url}users/self`).subscribe(
      res => {
        this.store.set('user', res.data);
      },
      err => {
        console.log(err);
        this.store.set('user', null)
      }
    )
  }

  public updateTimezone(data :any){
    const headers = new HttpHeaders({
      Authorization: `${this.getToken()}`
  });
  return this.http.put(`${this.url}ipj/user/time-zone`,data,{headers});
}
}